module.exports = __webpack_public_path__ + "img/1428145927.7961835c.jpg";